import { useEffect } from 'react'
import {
  CompetitionGroup,
  MatchStatus,
  useGetMatchForOverlayQuery,
} from '@plvs/graphql'
import { useParams } from 'react-router-dom'
import { defaultTo0, defaultToEmptyString } from '@plvs/utils'
import { Polling } from '@plvs/const'

type IdAndName =
  | {
      id: string
      name?: string | null
    }
  | null
  | undefined

export type MatchOverlayTeam =
  | {
      id: string
      avatarUrl?: string | null
      name?: string | null
      school?: {
        name?: string | null
      } | null
      competitionGroup?: CompetitionGroup | null
    }
  | null
  | undefined

type MatchOverlayReturn = {
  loading: boolean
  league: IdAndName
  metaseason: IdAndName
  homeTeam: MatchOverlayTeam
  awayTeam: MatchOverlayTeam
  slot: IdAndName
  team1Score: number
  team2Score: number
  isMatchPending: boolean
}

export function useMatchOverlay(): MatchOverlayReturn {
  const { matchId } = useParams<{ matchId: string }>()

  const { data, loading } = useGetMatchForOverlayQuery({
    variables: {
      matchId: defaultToEmptyString(matchId),
    },
    pollInterval: Polling.Normal,
  })

  const body = document.querySelector('body')
  const root = document.querySelector('#root')
  useEffect((): void => {
    if (body) {
      body.style.backgroundColor = 'transparent'
      body.style.overflow = 'hidden'
    }

    if (root) {
      // @ts-ignore `style` is a valid prop
      root.style.backgroundColor = 'transparent'
    }
  }, [
    body?.style.backgroundColor !== 'transparent',
    // @ts-ignore `style` is a valid prop
    root?.style.backgroundColor !== 'transparent',
  ])

  const match = data?.match
  const slot = match?.slot
  const league = slot?.phase?.season?.league
  const metaseason = slot?.phase?.season?.metaseason
  const homeTeam = match?.teamContext?.teams?.[0]
  const awayTeam = match?.teamContext?.teams?.[1]
  const team1Score = defaultTo0(match?.team1Score)
  const team2Score = defaultTo0(match?.team2Score)
  const isMatchPending = Boolean(
    match?.status &&
      [MatchStatus.Scheduled, MatchStatus.Rescheduled].includes(match?.status)
  )

  return {
    slot,
    loading,
    league,
    metaseason,
    homeTeam,
    awayTeam,
    team1Score,
    team2Score,
    isMatchPending,
  }
}
